<template>
  <div>
    <el-upload ref="elUpload"
      :action="actionUrl"
      :list-type="listType"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :name="name"
      :headers="headers"
      :accept="accept"
      :on-change="needCropper?handleChange:handleChange2"
      :auto-upload="!needCropper"
      multiple
      :before-upload="beforeUpload"
      :limit="limit"
      :on-exceed="onExceed"
      :file-list="fileList"
      :on-success="onSuccess"
      :data="otherData">
      <i class="el-icon-plus"></i>
    </el-upload>
    <div slot="tip" class="el-upload__tip">{{ tip }}</div>
    <el-form-item label="是否需要剪裁">
     <el-switch v-model="needCropper" > </el-switch>
    </el-form-item>
    <el-dialog :visible.sync="dialogVisible"
               :append-to-body="true">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>
    <el-dialog :visible.sync="showCropper"
          width="80vw"
          title="图片剪裁"
          :append-to-body="true"
          :show-close="false">
      <vue-cropper
            ref="cropper"
            :img="imgSrc"
            :autoCropWidth="autoCropWidth"
            :autoCropHeight="autoCropHeight"
            :autoCrop="true"
            style="width: 100%;height:800px;display: block;"
        ></vue-cropper>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelCropper">取 消</el-button>
          <el-button type="primary" @click="finish">确认</el-button>
        </div>
        <!-- <el-button type="primary" @click="finish" :loading="loading">确认</el-button> -->
    </el-dialog>
     <!--  -->
  </div>
</template>

<script>
import store from "../../store";
import fetch from '../../api/tianzheng/flie'
// import fetch from "../ /api/tianzheng/file";
export default {
  name: "ImageUpload",
  data () {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      name: "imgFile",
      listType: "picture-card",
      actionUrl: process.env.VUE_APP_BASE_API + "/common/uploadFile",
      headers: {
        Authorization: "",
      },
      otherData: {},
      accept: this.acceptType,
      limit: this.maxNumber,
      fileList: [],
      fileListTemp: [], // 中转
      imgSrc: null,
      showCropper: false,
      needCropper: false
    };
  },
  props: {
    imageList: {
      type: String,
      default: function () {
        return "";
      },
    },
    tipInfo: {
      type: String,
      default: function () {
        return "";
      },
    },
    maxNumber: {
      type: Number,
      default: function () {
        return 1;
      },
    },
    autoCropWidth: {
      type: Number,
      default: function () {
        return 300;
      },
    },
    autoCropHeight: {
      type: Number,
      default: function () {
        return 300;
      },
    },
    acceptType: {
      type: String,
      default: function () {
        return "image/*";
      },
    },
  },
  computed: {
    tip: function () {
      return this.tipInfo === ""
        ? this.$t("upload.defaultTipInfo")
        : this.tipInfo;
    },
  },
  watch: {
    imageList: function () {
      if (this.imageList) {
        this.fileList = JSON.parse(this.imageList);
        // console.log('typeof ===',typeof this.fileList)
        // this.fileListTemp = JSON.parse(this.imageList);
        // console.log('图片===', JSON.parse(this.imageList))
        this.$emit('updateImg', this.fileList);
      } else {
        this.fileList = [];
        this.$emit('updateImg', this.fileList);
      }
    },
  },
  created () {

  },
  methods: {
    clearFileList () {
      this.$refs["elUpload"].clearFiles();
      this.fileList = [];
    },
    handleRemove (file, fileList) {
      let fileListTemp = [];
      fileList.forEach(el => {
        if (el.response) {
          let obj = {
            path: el.response.result.url,
          }
          fileListTemp.push(obj)
        } else {
          let obj = {
            path: el.path,
          }
          fileListTemp.push(obj)
        }
      });
      this.fileList = fileList
      this.$emit('updateImg', fileListTemp);
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange(file, fileList) {
      if (!file.raw) return; // 检查是否有文件被选中
      const reader = new FileReader();
      reader.onload = (e) => {
        this.showCropper = true
        this.imgSrc = e.target.result; // 设置裁剪组件的图片源为读取的base64字符串
      };
      reader.readAsDataURL(file.raw); // 读取文件内容为DataURL，以便于在裁剪组件中使用。
    },
    handleChange2() {

    },
    cancelCropper() {
      this.showCropper = false
       console.log('cancelCropper 1:',this.fileList)
       console.log('cancelCropper:',this.$refs["elUpload"])
      //  this.clearFileList()
     this.$refs["elUpload"].uploadFiles.pop()
    },
    finish() {
      // this.$refs.cropper.getCropBlob((data) => {
      //    console.log('blob', data)
      //     fetch.uploadImg({ imgFile: data, language:'zh' }).then((res) => {
      //       console.log(res)
      //       if (res.code == 200) {
                
      //       }
      //   });
      // })
//  this.showCropper = false
//  return
      this.$refs.cropper.getCropData((data) => {
        
       let that = this
         console.log('data', data)
        // var imgs = data.replace(/^data:image\/\w+;base64,/, "");//去掉base64位头部
        //  console.log('imgs', imgs)
        fetch.uploadImg({ imgFile: data, language:'zh' }).then((res) => {
            console.log(res)
            if (res.code == 200) {
              that.showCropper = false
                let fileListTemp = [];
                let obj = {
                  name: res.result.filename,
                  path: res.result.url,
                  url: that.$publicData.imgUrl+res.result.url,
                }
                console.log(obj)
                
                if (that.$refs["elUpload"].uploadFiles.length>0) {
                  that.$refs["elUpload"].uploadFiles.pop()
                }
                console.log('fileList:',that.fileList)
                console.log('that.$refs["elUpload"]:',this.$refs["elUpload"])
                console.log('that.$refs["elUpload"].uploadFiles:',this.$refs["elUpload"].uploadFiles)

                that.fileList.push(obj)
                that.fileList.forEach(el => {
                  if (el.response) {
                    let obj = {
                      path: el.response.result.url,
                    }
                    fileListTemp.push(obj)
                  } else {
                    let obj = {
                      path: el.path,
                    }
                    fileListTemp.push(obj)
                  }
                });
                that.$emit('updateImg', fileListTemp);
            }
        });
      })
    },
    beforeUpload (file) {
      this.headers.Authorization = store.getters.token;
      this.otherData.language = store.getters.language;
    },
    onExceed (files, fileList) {
      this.$message.warning("最多可以上传" + this.limit + "张图片");
    },
    onSuccess (response, file, fileList) {
      if (response.code === 200) {
        let fileListTemp = [];
        console.log(fileList)
        fileList.forEach(el => {
          if (el.response) {
            let obj = {
              path: el.response.result.url,
            }
            fileListTemp.push(obj)
          } else {
            let obj = {
              path: el.path,
            }
            fileListTemp.push(obj)
          }
        });
        console.log('that.$refs["elUpload"]:',this.$refs["elUpload"])
        
         console.log('fileListTemp:',fileListTemp)
        this.$emit('updateImg', fileListTemp);
      } else {
        this.$message.error(response.message);
        fileList.splice(
          fileList.findIndex((item) => item.uid === file.uid),
          1
        );
      }
    },
  },
};
</script>

<style scoped>
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
</style>
